"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalS3FileUploader = void 0;
class ExternalS3FileUploader {
    constructor(presignedUploadURLProvider) {
        this.presignedUploadURLProvider = presignedUploadURLProvider;
    }
    uploadImage(content) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.presignedUploadURLProvider.getPresignedUploadURL();
                yield this.upload(response.url, content);
                return response.key;
            }
            catch (error) {
                console.log(error);
                throw new Error("Image Upload Failed");
            }
        });
    }
    upload(url, content) {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Length": content.size.toString(),
                    "Content-Type": "image/png"
                },
                body: content
            })
                .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
                .then(text => {
                resolve(text);
            })
                .catch(error => {
                reject(error);
            });
        });
    }
}
exports.ExternalS3FileUploader = ExternalS3FileUploader;
